<template>
  <div v-if="displayPopupContentFilterMobile">
    <div class="mobile-filter-header">
        <div @click="editFavorite()" class="btn-clear" v-if="mobileContentListTabIndex==0 && isAuthenticated"> {{$t('REPORT_FILTER').Favorite_Content}} </div>
        <div @click="backToContentListTab()" class="btn-clear" v-if="mobileContentListTabIndex==2 && isAuthenticated"> {{$t('BUTTONS').Back}} </div>
        <feather-icon
            icon="XIcon"
            :svgClasses="['h-6 w-6 btn-close']"
            @click.stop="onClose"
        ></feather-icon>
    </div>
    <feather-icon
        v-if="mobileContentListTabIndex==1"
        icon="ChevronLeftIcon"
        :svgClasses="['h-6 w-6']"
        class="feather-chevrons-left"
        @click.stop="mobileContentListTabIndex=0"
    ></feather-icon>
    <div class="px-6 flex flex-col" v-if="contents.analysis">
        <vs-tabs :position="'top'" class="h-full w-full mobile-content-list-tab" v-model="mobileContentListTabIndex">
            <vs-tab
                icon-pack="feather"
                icon="icon-shopping-bag"
            >
                <div class="filter-label filter-label-margin" v-if="contents.favorites.length > 0"><span>{{ $t("REPORT_FILTER").Favorite_Content }}</span></div>
                <div
                    class="flex justify-between items-center cursor-pointer mt-4"
                    v-for="(item) in contents.favorites"
                    :key="item._id"
                    :class="{
                        'disabled-item': !item.habilitado,
                        'text-primary stroke-current': isContentFilterSelected(item)
                    }"
                    @click="selectCurrentContent(item)"
                >
                    <div class="flex items-center">
                        <feather-icon
                        :icon="item.icone"
                        :svgClasses="['h-6 w-6']"
                        ></feather-icon>
                        <span class="text-lg ml-4">{{ item.nome }}</span>
                        
                        <span class="chevron-menu-mobile">
                            <feather-icon
                            icon="ChevronRightIcon"
                            :svgClasses="['h-6 w-6']"
                            v-if="item.reportType && item.reportType.length > 0"
                            ></feather-icon>
                            <feather-icon icon="StarIcon" :svgClasses="['h-6 w-6']" class="cursor-pointer favorite-content-icon favorite-content-selected"></feather-icon>
                        </span>
                    </div>
                </div>
                <div class="filter-label filter-label-margin"><span>{{ $t("REPORT_FILTER").Informative }}</span></div>
                <div
                    class="flex justify-between items-center cursor-pointer mt-4"
                    v-for="(item) in contents.analysis"
                    :key="item._id"
                    :class="{
                        'disabled-item': !item.habilitado,
                        'text-primary stroke-current': isContentFilterSelected(item)
                    }"
                    @click="selectCurrentContent(item)"
                >
                    <div class="flex items-center">
                        <feather-icon
                            :icon="item.icone"
                            :svgClasses="['h-6 w-6']"
                        ></feather-icon>
                        <span class="text-lg ml-4">{{ item.nome }}</span>
                        <span class="chevron-menu-mobile" v-if="item.reportType && item.reportType.length > 0">
                            <feather-icon
                                icon="ChevronRightIcon"
                                :svgClasses="['h-6 w-6']"
                            ></feather-icon>
                        </span>
                    </div>
                </div>
                <div class="filter-label filter-label-margin" v-if="contents.quotes.length > 0"><span>{{ $t("REPORT_FILTER").Follow_Market }}</span></div>
                <div
                    class="flex justify-between items-center cursor-pointer mt-4"
                    v-for="(item) in contents.quotes"
                    :key="item._id"
                    :class="{
                        'disabled-item': !item.habilitado,
                        'text-primary stroke-current': isContentFilterSelected(item)
                    }"
                    @click="selectCurrentContent(item)"
                >
                    <div class="flex items-center">
                        <feather-icon
                        :icon="item.icone"
                        :svgClasses="['h-6 w-6']"
                        ></feather-icon>
                        <span class="text-lg ml-4">{{ item.nome }}</span>
                    </div>
                </div>

            </vs-tab>
            <vs-tab
                icon-pack="feather"
                icon="icon-shopping-bag"
            >

                <div class="filter-label filter-label-margin">
                <!-- <span>{{ $t("REPORT_FILTER").Filter_Report_Type }}</span> -->
                    <span>{{ currentContentName }}</span>
                </div>
                <div
                    class="cursor-pointer submenu-mob statistics-export-import"
                    v-for="(reportTypeGroup, index) in currentReportTypeList"
                    :key="index"
                >
                    <!-- :class="{
                        'text-primary sidebar-reporttype-item current': isCurrentReportTypeSelected(reportTypeGroup)
                    }" -->
                    <section v-if="reportTypeGroup.session" class="flex items-center" @click="displayReportTypeGroup(reportTypeGroup.id)">
                        <div>{{ reportTypeGroup.session }}</div>
                        <feather-icon 
                            :icon="getCurrentReportTypeGroupIcon(reportTypeGroup.id)" 
                            :svgClasses="['h-5 w-5']" 
                            class="cursor-pointer list-content-reporttype-icon" 
                            v-if="reportTypeGroup && reportTypeGroup.session" 
                            style="color: #626262;"
                        >
                        </feather-icon>
                    </section>
                    <template v-if="isOpen(reportTypeGroup.id)">
                        <span
                            v-for="(reportType, index) in reportTypeGroup.items"
                            :key="index"
                            @click="selectReportType(reportType)"
                            class="report-type-group-item"
                            :class="{
                                'report-type-item-mobile': reportTypeGroup.items.length > 0,
                                'text-primary sidebar-reporttype-item current': isCurrentReportTypeSelected(reportType)
                            }"
                        >
                            {{ reportType.name }}
                        </span>
                    </template>
                    <span
                        v-for="(typesOfReportsWithoutGroups, j) in reportTypeGroup.typesOfReportsWithoutGroups"
                        :key="j+1"
                        @click="selectReportType(typesOfReportsWithoutGroups)"
                        :class="{
                                'report-type-item-mobile': reportTypeGroup.typesOfReportsWithoutGroups.length > 1,
                                'text-primary sidebar-reporttype-item current': isCurrentReportTypeSelected(typesOfReportsWithoutGroups)
                        }"
                    >
                        {{ typesOfReportsWithoutGroups.name }}
                    </span>
                </div>
            </vs-tab>
            <vs-tab
                icon-pack="feather"
                icon="icon-shopping-bag"
            >
                <div class="filter-label filter-label-margin" v-if="contents.favorites.length > 0"><span>{{ $t("REPORT_FILTER").Favorite_Content }}</span></div>
                <div
                    class="flex justify-between items-center cursor-pointer mt-4"
                    v-for="(item) in contents.favorites"
                    :key="item._id"
                    :class="{
                        'disabled-item': !item.habilitado,
                    }"
                    @click="selectFavorite(item)"
                >
                    <div class="flex items-center">
                        <feather-icon
                        :icon="item.icone"
                        :svgClasses="['h-6 w-6']"
                        ></feather-icon>
                        <span class="text-lg ml-4">{{ item.nome }}</span>
                        
                        <span class="chevron-menu-mobile">
                            <feather-icon icon="StarIcon" :svgClasses="['h-6 w-6']" class="cursor-pointer favorite-content-icon favorite-content-selected"></feather-icon>
                        </span>
                    </div>
                </div>
                <div class="filter-label filter-label-margin"><span>{{ $t("REPORT_FILTER").Informative }}</span></div>
                <div
                    class="flex justify-between items-center cursor-pointer mt-4"
                    v-for="(item) in contents.analysis"
                    :key="item._id"
                    :class="{
                        'disabled-item': !item.id,
                    }"
                    @click="selectFavorite(item)"
                >
                    <div class="flex items-center">
                        <feather-icon
                        :icon="item.icone"
                        :svgClasses="['h-6 w-6']"
                        ></feather-icon>
                        <span class="text-lg ml-4">{{ item.nome }}</span>
                        <span class="chevron-menu-mobile" v-if="item.id">
                            <feather-icon icon="StarIcon" :svgClasses="['h-6 w-6']" class="cursor-pointer favorite-content-icon"></feather-icon>
                        </span>
                    </div>
                </div>
                <div class="filter-label filter-label-margin" v-if="contents.quotes > 0"><span>{{ $t("REPORT_FILTER").Follow_Market }}</span></div>
                <div
                    class="flex justify-between items-center cursor-pointer mt-4"
                    v-for="(item) in contents.quotes"
                    :key="item._id"
                    :class="{
                        'disabled-item': !item.habilitado,
                    }"
                    @click="selectFavorite(item)"
                >
                    <div class="flex items-center">
                        <feather-icon
                        :icon="item.icone"
                        :svgClasses="['h-6 w-6']"
                        ></feather-icon>
                        <span class="text-lg ml-4">{{ item.nome }}</span>
                        <span class="chevron-menu-mobile">
                            <feather-icon icon="StarIcon" :svgClasses="['h-6 w-6']" class="cursor-pointer favorite-content-icon"></feather-icon>
                        </span>
                    </div>
                </div>
            </vs-tab>
        </vs-tabs>
    </div>
    </div>
</template>

<script>
import AppConstants from '../../../appConstants';
import { EventBus } from '../../../event-bus';
import messageDialogHelper from '../../../helpers/message-dialog-helper';

export default {
    data() {
        return {
            mobileContentListTabIndex: 0,
            openGroups: {},
            previousContent: null,
        }
    },
    props: {
        displayPopupContentFilterMobile: Boolean,
        contents: Object,
        currentContentName: String
    },
    computed: {
        currentContent() {
            return this.$store.state.currentContent;
        },
        currentReportType() {
            return this.$store.state.currentReportType;
        },
        isAuthenticated() {
            return this.$store.state.isAuthenticated;
        },
        currentReportTypeList() {
            if (this.currentContent.reportType) {
            return this.currentContent.reportType;
            }
            return [];
        },
    },
    methods: {
        getCurrentReportTypeGroupIcon(id) {
            return this.openGroups[id] ? 'ChevronUpIcon' : 'ChevronDownIcon';
        },
        displayReportTypeGroup(reportTypeGroupId) {
            this.$set(this.openGroups, reportTypeGroupId, !this.openGroups[reportTypeGroupId]);
        },
        isOpen(id) {
            return this.openGroups[id] || false;
        },
        onClose() {
            this.backToContentListTab();
            this.$emit('close');
        },
        backToContentListTab() {
            this.mobileContentListTabIndex = 0;
        },
        selectFavorite(val) {
            if (!val.id) {
                return;
            }
            this.$emit('updateFavoriteList', val);
        },
        editFavorite() {
            this.mobileContentListTabIndex = 2;
        },
        changeDisplayPopup(val) {
            this.$emit('changeDisplayPopup', val);
        },
        selectCurrentContent(content) {
            if (content.isLabel) return;
            if (!content.habilitado) {
                this.openUserRightsModal(content);
                return;
            }
            if (content.isQuotes && (!this.isAuthenticated || !content.quotesDisplayDetail)) {
                // console.log('[quotesDisplayDetail]');
                this.$emit('displayExclusiveContent');
                this.changeDisplayPopup(false);
                return;
            }
            if (this.currentContent && this.currentContent.id !== content.id) {
                this.previousContent = { ...this.currentContent }; 
            }
            if (content.reportType && content.reportType.length > 0) {
                this.mobileContentListTabIndex = 1;
            
            } else {
                this.mobileContentListTabIndex = 0;
                this.changeDisplayPopup(false);
                this.$store.dispatch("updateCurrentReportType", { id: null });
            }
            
            this.$store.dispatch("updateCurrentContent", content);
            this.$emit('updateHeaderMobileCurrentContent');
            this.$emit('reloadDataWithFilter', {selectedFilter: this.selectedFilter});
            // this.reloadDataWithFilter({selectedFilter: this.selectedFilter});
            this.$forceUpdate();
            this.updateFilter();
        },
        openUserRightsModal(item) {
            messageDialogHelper.displayUserRightsMessage(item.nome, () => {
                EventBus.$emit(AppConstants.BUS_EVENT_OPENA_ATTENDANCE);
            });
        },
        isContentFilterSelected(item) {
            if (this.currentContent) {
            return this.currentContent.id == item.id;
            }
            return false;
        },
        isCurrentReportTypeSelected(item) {
            if (this.currentReportType) {
            return this.currentReportType.id == item.id
            }
            return false;
        },
        selectReportType(item) {
            this.$store.dispatch("updateCurrentReportType", item);
            this.mobileContentListTabIndex = 0;
            this.changeDisplayPopup(false);
            this.$emit('reloadDataWithFilter', {selectedFilter: this.selectedFilter});
            // this.reloadDataWithFilter({selectedFilter: this.selectedFilter});
        },
        updateFilter() {
            this.$emit("updateFilter", { previousContent: this.previousContent });
        }
        
    }
}
</script>

<style>

</style>